<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 21H23.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 10.5C14.6716 10.5 14 11.1716 14 12V17C14 17.8284 14.6716 18.5 15.5 18.5H16.5C17.3284 18.5 18 17.8284 18 17V12C18 11.1716 17.3284 10.5 16.5 10.5H15.5Z" fill="currentColor"/>
</svg>
